import { Outlet } from "react-router-dom";

const Inventory = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Inventory;
